import type React from 'react';
import clsx from 'clsx';

const toneClassNames = {
  error:
    'border-red-200 bg-red-50 text-red-900 dark:border-red-500/30 dark:bg-red-500/10 dark:text-red-200',
  warning:
    'border-amber-200 bg-amber-50 text-amber-900 dark:border-amber-500/30 dark:bg-amber-500/10 dark:text-amber-200',
  info: 'border-sky-200 bg-sky-50 text-sky-900 dark:border-sky-500/30 dark:bg-sky-500/10 dark:text-sky-200'
};

/** A notice in a page's flow: a title, what it means, and what the reader can do about it. */
export const InlineNotice = (props: {
  tone: keyof typeof toneClassNames;
  title: string;
  description?: React.ReactNode;
  actions?: React.ReactNode;
  className?: string;
}) => (
  <div
    role={props.tone === 'error' ? 'alert' : 'status'}
    className={clsx(props.className, 'rounded-lg border p-4', toneClassNames[props.tone])}
  >
    <p className="m-0 text-sm font-semibold">{props.title}</p>
    {props.description && <p className="m-0 mt-1 text-sm">{props.description}</p>}
    {props.actions && <div className="mt-2 flex flex-wrap gap-2">{props.actions}</div>}
  </div>
);
